<template>
  <div class="prepare-container">
    <div class="test-bg" v-if="!showList.length" :class="{'test-bg-Tablet':isTablet}">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <el-table
    :data="showList"
    style="width: 100%"
     v-else
    >
    <el-table-column
      prop="evaluate_name"
      label="名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.evaluate_name}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="right_num"
      label="预习进度"
      width="150"
      align="center"
      >
        <template slot-scope="scope">
          <div>
          {{scope.row.right_num}}/{{scope.row.total_num}}
          </div>
        </template>
    </el-table-column>
     <el-table-column
      prop="created"
      label="发布时间"
      width="250"
      align="center"
      sortable>
    </el-table-column>
    <el-table-column
      label="操作"
      align="center"
      width="150"
      >
       <template slot-scope="scope">
          <a @click="handlerClick(scope.row)" class="go-record">查看</a>
        </template>
    </el-table-column>
    </el-table>
       <!-- 分页控件 -->
    <div class="prepare-pagination" v-if="showList.length">
      <el-pagination
       background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/pages/uc-web/api/api';
import { userAgentType } from '@/utils/index';
// import { getSign } from '@/pages/uc-web/utils/verify';

export default {
  name: 'PrepareRecord',
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    prevList: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      default: 10,
      type: Number,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
      isTablet: false,
    };
  },
  mounted() {
    this.isTablet = userAgentType().isTablet;
  },
  methods: {
    async handlerClick(row) {
      localStorage.setItem('evaluate_name', row.evaluate_name);
      const params = {
        school_id: localStorage.getItem('school_id'),
        account_id: localStorage.getItem('account_id'),
        evaluate_id: row.evaluate_id,
        type: 2,
      };
      const res = await api.getStuTaskTokenInfo(params);
      console.log(res.data);
      const tokenParams = { jupiterToken: res.data };
      const data = await api.mtLogin(tokenParams);
      localStorage.setItem('uc-mtLoginToken', data.token);
      if (data.code === 200) {
        this.$emit('applyOne');
        this.$router.push({
          path: '/uc-web/preview',
          query: {
            hwId: row.evaluate_id,
          },
        });
      } else {
        this.$toast(data.msg);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.pageSize = val;
      this.$emit('changePageSize', val);
      // localStorage.setItem('pageSize', val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // this.currentPage = val;
      this.$emit('changeCurrent', val);
      localStorage.setItem('currentPage', val);
    },
  },
  computed: {
    showList() {
      if (this.activeId === '0') {
        return this.prevList;
      }
      return this.prevList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.prepare-container{
  font-family: PingFangSC-Medium, PingFang SC;
  // position: relative;
  .test-bg-Tablet{
    width: 100% !important;
  }
  .test-bg{
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      span{
        position: absolute;
        left: 50%;
        transform: translate(-50%,70px);
        font-size: 14px;
        font-weight: 400;
        color: rgba(17, 31, 44, 0.6);
      }
  }
  .go-record{
    font-weight: 500;
    color: #1989FA;
    cursor: pointer;
  }
  .prepare-pagination{
    height: 103px;
    display: flex;
    align-items: center;
  }
}

  /deep/.el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    // position: absolute;
    width: calc(100% - 64px);
    // bottom: 30px;
    // left: 32px;
    .btn-prev {
      margin-left: auto !important;
    }
  }
</style>
